<template>
<div class="form-wrapper">
    <div class="confirmation">
        <card-header :title="'Join or create account?'" :designVersion="2" />
        <div class="body">
            <div class="spinner" :class="{'hidden': !isSubmitting}"><i class="fa fa-spinner fa-pulse"></i></div>
            <paragraph :class="{'hidden': isSubmitting}" id="already-registered-text" :type="'p'" :variation="'medium'">
                Your organization has an existing account. Would you like to join this account or create a new one?
            </paragraph>
            <br />
            <div class="form-group" :class="{'hidden': isSubmitting}">
                <div class="button-wrapper">
                    <custom-button v-if="!isSubmitting" :text="'Join existing account'" id="join-existing-account-btn"  @click="signUpWithExistingAccount" :size="'button-large'"></custom-button>
                    <br />
                    <paragraph :class="{'hidden': isSubmitting}" :type="'p'" :variation="'medium'">
                        Or
                    </paragraph>
                    <custom-button v-if="!isSubmitting" :text="'Create new account'" id="create-new-account-btn" @click="signUp" :size="'button-large'"></custom-button>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
/* eslint-disable import/extensions */
import '~/assets/js/global.js';
import _ from 'lodash';
import CardHeader from './card-header.vue';
import Validate from '~/mixins/validation.js';
import PasswordInputWithSuggestion from '~/components/shared/password-input-with-suggestion.vue';
import { signUpEuCentral } from '~/assets/js/utils/ab-aws-migration.js';
import Heading from '~/components/shared/heading.vue';
import Paragraph from '~/components/shared/paragraph.vue';
import InputSet from '~/components/shared/input-set.vue';
import CustomButton from '~/components/shared/custom-button.vue';
import { newIndustries } from '~/assets/constants/industries.js';

export default {
    components: {
        // eslint-disable-next-line vue/no-unused-components
        CardHeader, Heading, Paragraph, InputSet, CustomButton, PasswordInputWithSuggestion,
    },
    mixins: [Validate],
    data() {
        return {
            password: '',
            email: '',
            firstName: '',
            lastName: '',
            dialCode: '1',
            itiPhone: null,
            phoneNumberInput: '',
            isSubmitting: false,
            showPassword: false,
            strength: 0,
            emptyFieldErrorMessage: 'This field cannot be empty',
            industry: '',
            industries: newIndustries,
            accountId: '',
        };
    },
    props: {
        userData: Object,
    },
    computed: {
        buttonState() {
            let state = this.firstName && this.lastName && this.password && this.email && this.industry && this.strength >= 3;
            state = state && _.values(this.errors).every((error) => error === '');
            return !!state;
        },
        phoneNumber() {
            const finalPhoneNumber = this.phoneNumberInput ? `+${this.dialCode.toString()}${this.phoneNumberInput.toString()}` : '';
            return finalPhoneNumber;
        },
    },
    methods: {
        checkboxClass(state) {
            const icon = state ? 'check-' : '';
            const fill = state ? 'fa' : 'far';
            return `${fill} fa-${icon}square`;
        },
        createHubspotContact() {
            const payload = {
                email: this.userData.email,
                first_name: this.userData.firstName,
                last_name: this.userData.lastName,
                phone_number: this.userData.phoneNumber,
                industry: this.userData.industry,
                form_used: 'Signup Form',
            };
            this.doBackendRequest(
                'POST',
                '/api/create_hubspot_contact_without_login',
                undefined,
                JSON.stringify(payload),
                undefined,
            );
        },
        signUpWithExistingAccount() {
            // accountId
            // eslint-disable-next-line prefer-const
            let self = this;
            this.isSubmitting = true;
            this.doBackendRequest(
                'GET',
                `/api/get_account_for_new_user?email=${self.userData.email}`,
                (res) => {
                    if (res) {
                        self.accountId = res;
                        self.signUp();
                    }
                },
                undefined,
                undefined,
            );
        },
        authSignUp() {
            const self = this;
            // eslint-disable-next-line prefer-const
            let payload = {
                email: self.userData.email,
                password: self.userData.password,
                firstName: self.userData.firstName,
                lastName: self.userData.lastName,
                industry: self.userData.industry,
                phoneNumber: self.userData.phoneNumber,
            };
            if (self.accountId) {
                payload.accountId = self.accountId;
            }
            signUpEuCentral(
                payload,
                () => {
                    self.$emit('verify_account', [self.userData.email, self.userData.password]);
                    self.createHubspotContact();
                },
                (err) => {
                    if (err.code === 'UserLambdaValidationException') {
                        self.errors.email = 'Email domain is not allowed. You must use a company email.';
                    } else if (err.code === 'NetworkError') {
                        self.errors.email = 'Request to Amazon Cognito failed. NoScript and AdBlockers may be blocking requests necessary for signup';
                    } else {
                        self.errors.email = 'There was an error creating your account.';
                    }
                    self.isSubmitting = false;
                },
            );
        },
        signUp() {
            const self = this;
            if (typeof posthog !== 'undefined') {
                // eslint-disable-next-line no-undef
                posthog.identify(self.userData.email);
            }
            this.isSubmitting = true;
            this.authSignUp();
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~/scss/pages/signup.scss';

</style>
